import React, { useEffect, useContext, useState, useRef, useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import llacFav from "../../img/LLAC-favicon.ico";

import { Helmet } from "react-helmet-async";

import AuthContext from "../../context/auth/authContext";
import queryString from "query-string";

import Logo from "../../components/layout/Logo";

const AdminLogin = () => {
  const [loginError, setLoginError] = useState(false);
  const location = useLocation();
  const authContext = useContext(AuthContext);
  const { socialLogin, user } = authContext;
  const processedTokenRef = useRef(null);

  const query = useMemo(() => queryString.parse(location.search), [location.search]);

  useEffect(() => {
    if (query.auth && query.auth !== processedTokenRef.current) {
      processedTokenRef.current = query.auth;
      socialLogin(query.auth);
    } else if (query.failure) {
      console.log('LoginPage: Login failure detected');
      setLoginError(true);
    }
  }, [query.auth, query.failure]);

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <section id="admin-login">
      {loginError && (
        <div className="login-failure-notification">
          <div className="notification-body">
            <p>You are not authorized to have access to this application</p>
            <p>Please reach out to techonology services for more infromation</p>
          </div>
        </div>
      )}
      <Helmet>
        <meta charSet="utf-8" />
        <title>Enrollment Login</title>
        <link rel="icon" type="image/x-icon" href={llacFav} />
      </Helmet>
      <div className="login-card">
        <div className="top">
          <Logo size={2} />
        </div>
        <div className="body">
          <a
            href={
              import.meta.env.VITE_NODE_ENV === "production" || import.meta.env.VITE_NODE_ENV === "staging"
                ? `/auth/azure?brand=${encodeURIComponent(window.location.origin)}`
                : `http://localhost:5000/auth/azure?brand=${encodeURIComponent(window.location.origin)}`
            }
            className="btn btn-llac-light-green"
          >
            <FaIcons.FaWindows className="login-icon" />
            0365 Login
          </a>
        </div>
      </div>
    </section>
  );
};

export default AdminLogin;
